module.exports = __webpack_public_path__ + "static/media/undraw_winners_ao2o1.c0aea85c.svg";